import React from 'react';
import styles from './Style.module.css';
import Skeleton from 'react-loading-skeleton';

const TimeSlotsLoader = () => {
  const skeletonCount = 28;

  return (
    <div className={`${styles.timeSlots} ${styles.timeSlotsLoader}`}>
      {Array.from({ length: skeletonCount }).map((_,index) => (
        <div key={index} className={styles.timeSlot}>
          <Skeleton />
        </div>
      ))}
    </div>
  );
};

export default TimeSlotsLoader;
